export const statuses = {
    "EXECUTION_OF_APPLICATION": "Оформление заявки",
    "RECONCILIATION_OF_DATA": "Согласование заявки",
    "WAITING_FOR_DELIVERY": "Ожидание доставки",
    "ARCHIVE": "Архив"
}